export const CLEAR_EVERYTHING = 'CLEAR_EVERYTHING';

interface CLEAR_EVERYTHING_ACTION {
  type: any;
}

export type RootActionType = CLEAR_EVERYTHING_ACTION;
